import React from 'react';
import Navbar from '../components/Navbar'; // ✅ Import it
import '../styles/login.css';

const Login = () => {
  return (
    <div className="login-container">
      <Navbar />  {/* ✅ Show Navbar at the top */}
      
      <div className="login-box">
        <div className="login-logo">
          <img src="/images/logo.png" alt="Watan Logo" />
        </div>

        <h1 className="welcome-text">Welcome Back</h1>

        <div className="input-group">
          <label htmlFor="username">Username / National ID</label>
          <input type="text" id="username" />
        </div>

        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input type="password" id="password" />
        </div>

        <div className="forgot-password">
          <a href="#">Forgot Password?</a>
        </div>

        <button className="login-button">Login</button>

        <div className="signup-link">
          Don't have an account? <a href="#">Sign Up</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
